export default __webpack_public_path__ + "static/media/check.2f43838d.svg";